export class ErroApp {
    cabecalho: string;
    rodape: string;
    codigoErro: string;
    listaComentarios: string[];

    constructor(codigoErro: string, cabecalho: string, rodape: string, listaComentarios: string[])
    {
        this.codigoErro = codigoErro;
        this.cabecalho = cabecalho;
        this.rodape = rodape;
        this.listaComentarios = listaComentarios;
    }

    toString(): string
    {
        if (this.listaComentarios != null && this.listaComentarios.length > 0)
        {
            return this.cabecalho + ": " + this.listaComentarios.join(', ') + '<br/>' +this.rodape;
        }
        return this.cabecalho +  '<br/>' + this.rodape;
    }
}
